import React from "react";
import Translator from "Languages/Utility/Translator";
import * as Icons from "react-bootstrap-icons";

export default function TypeAddFormatter(cell, admin_interface = true) {
  return (
    <div className={admin_interface && `satpa_num${cell}`}>
      {admin_interface &&
        {
          1: <Icons.Bag size={15} />,
          2: <Icons.ArrowUpCircle size={15} />,
          3: <Icons.ExclamationCircle size={15} />,
        }[cell]}{" "}
      <Translator id={`satpa_num${cell}`} noSpan />
      {cell !== 1 && cell !== 2 && cell !== 3 && <Translator id="undefined" />}
    </div>
  );
}
